/** @jsx jsx */
import { jsx } from '@emotion/react';

import type * as React from 'react';

import { LoadingSection } from '@coursera/cds-core';

import SkillEntityContext from 'bundles/browse-common/contexts/SkillEntityContext';
import { useBrowseSkillsPageEntity } from 'bundles/browse-common/hooks/useSkillsPageEntity';
import { NotFound } from 'bundles/common/components/withNotFound';

import _t from 'i18n!nls/browse-common';

type Props = {
  skillSlug: string;
  children: React.ReactNode;
};

const SkillEntityProvider = (props: Props) => {
  const { skillSlug, children } = props;

  const { entity, loading } = useBrowseSkillsPageEntity(skillSlug);

  if (loading) {
    return <LoadingSection label={_t('Fetching data...')} />;
  }

  if (!entity) {
    return <NotFound />;
  }

  return <SkillEntityContext.Provider value={entity}>{children}</SkillEntityContext.Provider>;
};

export default SkillEntityProvider;
